import React, { useState, useEffect, useCallback } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useUser } from "../../context/UserContext";
import { endpoints } from "../../../api/endpoints";
import { getFetcher } from "../../../api/fetchers";
import Spinner from "../spinner/Spinner";
import ProductCart from "../ProductCart";
import { useLanguage } from "../../context/LanguageContext";

interface Product {
  id: string;
  name: string;
  price: number;
  description: string;
  images: string;
  rating: number;
  discount: number;
}

interface FavoriteProduct {
  id: string;
  productId: string;
  userId: string;
  status: boolean;
  favoriteDate: string;
  priceAtFavorite: number;
  product: Product;
}

const Favorites: React.FC = () => {
  const { t } = useLanguage();
  const [favoriteProducts, setFavoriteProducts] = useState<FavoriteProduct[]>(
    []
  );
  const { user } = useUser();
  const [loading, setLoading] = useState<boolean>(true);
  //const [favoriteProductIds, setFavoriteProductIds] = useState<Set<string>>( new Set<string>() );
  const [userBusinessPackage, setUserBusinessPackage] = useState<any>();
  
  const fetchProducts = useCallback(async () => {
    try {
      if (!user) {
        throw new Error("User not found");
      }

      const response = await getFetcher(
        `${endpoints.user.getFavorites}/${user.id}`
      );
      if (response?.result) {
        const productsWithImagesParsed = response.favoriteProducts.map(
          (favoriteProduct: FavoriteProduct) => {
            return {
              ...favoriteProduct,
              product: {
                ...favoriteProduct.product,
                images: favoriteProduct.product.images,
              },
            };
          }
        );
        setFavoriteProducts(productsWithImagesParsed);
      } else {
        console.log("Error!");
      }
    } catch (error: any) {
      if (error.response?.status === 404) {
        setFavoriteProducts([]);
      } else {
        console.error("Error fetching favorite products:", error);
      }
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      fetchProducts();
    } else {
      setLoading(false);
    }
  }, [user, fetchProducts]);

  const fetchBusinessPackageData = async () => {
    if (user) {
      try {
        const businessPackage = await getFetcher(
          endpoints.user.getBusinessPackageById.replace(
            "{id}",
            user.businessPackageId
          )
        );
        if (businessPackage.result) {
          setUserBusinessPackage(businessPackage.businessPackage);
        }
      } catch (error) {
        console.error("Error fetching business package:", error);
      } finally {
        console.log("first");
      }
    } else {
      console.log("err");
    }
  };

  useEffect(() => {
    fetchBusinessPackageData();
  }, [user]);

  if (loading) {
    return <Spinner />;
  }

  return (
    <div className="p-4 md:px-6 md:py-4 h-full rounded-lg">
      <ToastContainer position="top-right" />
      <div className=" overflow-y-auto h-full max-h-full">
        <h5 className="text-primary-color text-3xl font-semibold">
          {t("favorites", "title")}
        </h5>
        {favoriteProducts.length === 0 ? (
          <div className="flex justify-center items-center h-full">
            <p className="text-lg font-semibold">{t("favorites", "noData")}</p>
          </div>
        ) : (
          <div className="md:px-6 md:py-4 flex flex-wrap items-center justify-center md:justify-start gap-2">
            {favoriteProducts.map(({ product, index }: any) => (
              <ProductCart
                product={product}
                key={index}
                userBusinessPackage={userBusinessPackage}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Favorites;